/** Reuse the site's icon library; no separate city icon system. */
export function cityIcon(name: string): SVGSVGElement {
  const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  icon.setAttribute('viewBox', '0 0 24 24');
  icon.setAttribute('aria-hidden', 'true');
  icon.classList.add('city-icon');
  if (name === 'globe' || name === 'languages' || name === 'map-pin') {
    icon.setAttribute('fill', 'none');
    icon.setAttribute('stroke', 'currentColor');
    icon.setAttribute('stroke-width', '1.75');
    icon.setAttribute('stroke-linecap', 'round');
    icon.setAttribute('stroke-linejoin', 'round');
    const paths = name === 'globe'
      ? ['M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20', 'M2 12h20', 'M12 2c-3 3-4.5 6.5-4.5 10S9 19 12 22', 'M12 2c3 3 4.5 6.5 4.5 10S15 19 12 22']
      : name === 'map-pin'
        ? [
          'M3 5.5 8.5 3l6 2.5L21 3v15.5l-6.5 2.5L8.5 18.5 3 21Z',
          'M8.5 3v15.5',
          'M14.5 5.5v2',
          'M17.1 8.8a2.65 2.65 0 0 0-2.65 2.65c0 1.9 2.65 4.8 2.65 4.8s2.65-2.9 2.65-4.8a2.65 2.65 0 0 0-2.65-2.65Z',
          'M17.1 11.45h.01',
        ]
        : ['M4 7h10', 'M9 4v3', 'M4 10c2.5 2.7 5.5 4.8 9 6', 'M12 8c-1.8 3.2-4.8 6.1-8 7.5', 'm14 21 3-8 3 8', 'M15 18h4'];
    for (const data of paths) {
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', data);
      icon.append(path);
    }
    return icon;
  }
  if (name === 'smartphone') {
    const frame = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    for (const [key, value] of Object.entries({x:'5', y:'2', width:'14', height:'20', rx:'2'})) frame.setAttribute(key, value);
    const home = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    home.setAttribute('d', 'M12 18h.01');
    icon.append(frame, home);
    return icon;
  }
  const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
  use.setAttribute('href', `/static/site-builder/base/icons.svg#${name}`);
  icon.append(use);
  return icon;
}
